module.exports = __webpack_public_path__ + "media/images/country_flags/mv-32495de04f12c4c2025a722f291ada03.png";